import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import {GetCategoriesResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.types';
import React from 'react';
import {CategorySlider} from '../../../features/CategorySlider/CategorySlider';
import {CategorySliderLoading} from '../../../features/CategorySlider/CategorySliderLoading';
import {useAppliedPotentialFilters} from '../../../features/ProductStream/utils';
import {useBrandShopPath} from '../utils/useBrandShopPath';
import {useCategoryIdentifier} from '../utils/useCategoryIdentifier';
import {useFiltersHeaderData} from '../utils/useFiltersHeaderData';
import {usePathWithBrandFilter} from '../utils/usePathWithBrandFilter';

export const BrandShopCategorySlider: React.FC<PriorityConfig> = ({
  renderingPriority,
}) => {
  return (
    <DataFetcher
      request={useFiltersHeaderData()}
      Error={null}
      Loading={CategorySliderLoading}
      View={BrandShopCategorySliderView}
      renderingPriority={renderingPriority}
    />
  );
};

const BrandShopCategorySliderView: React.FC<GetCategoriesResponse> = ({
  categories,
  ...otherProps
}) => {
  const categoryIdentifier = useCategoryIdentifier();
  const brandShopPath = useBrandShopPath();
  const categoryPathWithBrandFilter = usePathWithBrandFilter();
  const hasAppliedFilters = Boolean(
    Object.keys(useAppliedPotentialFilters()).length,
  );

  return (
    <CategorySlider
      activeCategoryId={categoryIdentifier?.identifier.id}
      categories={categories.map(category => ({
        category: {
          ...category,
          path: categoryPathWithBrandFilter(category.path),
        },
        hasProducts: true,
        targetPath: brandShopPath(category.id),
      }))}
      useButtonLink={hasAppliedFilters}
      {...otherProps}
    />
  );
};
